import { useCaseMetricsQuery } from 'src/graphql';

export interface CaseMetrics {
  caseLead: number;
  teamMember: number;
  waitingForResponse: number;
  isLoading: boolean;
  isError: boolean;
}

export const useCaseMetrics = (): CaseMetrics => {
  const { data, isLoading, isError } = useCaseMetricsQuery();

  return {
    caseLead: data?.caseMetrics?.caseLeadCount ?? 0,
    teamMember: data?.caseMetrics?.teamMemberCount ?? 0,
    waitingForResponse: data?.caseMetrics?.waitingForResponseCount ?? 0,
    isLoading,
    isError,
  };
};
